import { render, staticRenderFns } from "./IconFolderOpenSolid.vue?vue&type=template&id=553c573b"
import script from "./IconFolderOpenSolid.vue?vue&type=script&lang=js"
export * from "./IconFolderOpenSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports